module.exports = __webpack_public_path__ + "img/44.724d1df5.jpg";